import { render } from "./BuyTicketComponent.vue?vue&type=template&id=6882b490"
import script from "./BuyTicketComponent.vue?vue&type=script&lang=js"
export * from "./BuyTicketComponent.vue?vue&type=script&lang=js"

import "./BuyTicketComponent.vue?vue&type=style&index=0&id=6882b490&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__